import React from 'react';
import {connect} from 'react-redux';
import {Redirect, Route, Switch} from 'react-router';
import PropTypes from 'prop-types';
import LoadingComponent from '../../../../assets/LoadingComponent';
import lodash from 'lodash';


import locales from 'locales';
import projectConfig from 'config';
import graphConfig from './config';
import {addNotification as addNotificationAction} from '../../../../services/notification/action';


import {confirmActionRequested} from '../../../../services/confirmAction/action';
import './styles/index.css';
import GraphEditor from './containers/GraphEditor';
import Tags from './components/TagsEdit';

import GrapMenu from './components/GraphMenu';
import {
  addNodeForButton as addNodeForButtonApi,
  connectEdgeToDestination as connectEdgeToDestinationApi,
  deleteNode as deleteNodeaApi,
  editNode as editNodeApi,
  fetchGraph,
  getCompany,
} from './services/api';

const notificationOptParams = {
  position: 'tr',
};

const NodeMessagesLocalized = {
  ENGLISH: 'New Question',
};

class Graph extends React.Component {
  constructor(props) {
    super(props);

    const { user } = this.props;
    let readonly = false;
    if (graphConfig.readOnlyRoles.includes(user.role)) {
      readonly = true;
    }

    this.state = {
      clientId: -1,
      activeTreeId: -1,
      draftTreeId: -1,
      rootNodeId: -1,
      nodes: [],
      edges: [],
      loading: false,
      readonly,
      locale: projectConfig.defaultLocaleOption.value,
      localizedNodes: [],
      selectedLocaleOption: projectConfig.defaultLocaleOption,
    };
  }

  componentDidMount() {
    const { addNotification, match: { params: { clientId } }, user: { language } } = this.props;
    this.setState({
      loading: true,
      clientId,
    });

    getCompany(clientId).then((res) => {
      const { activeTreeId, draftTreeId } = res;

      this.setState({
        activeTreeId,
        draftTreeId,
      });

      return fetchGraph(activeTreeId).then((response) => {
        const { locale } = this.state;

        const { nodes, rootId } = response;
        nodes.forEach((node) => {
          if (node.buttons === null) {
            node.buttons = [];
          }
        });

        this.setState({
          rootNodeId: rootId,
          nodes,
          edges: response.edges,
          localizedNodes: Graph.localizeNodesData(nodes, locale),
        });
      });
    }).catch(() => {
      addNotification(`${locales[language].somethingWentWrong}`, projectConfig.notificationLevels.error);
    }).finally(() => {
      this.setState({
        loading: false,
      });
    });
  }

  handleLocaleChange = (selectedLocaleOption) => {
    const { nodes, selectedLocaleOption: previousSelectedLocaleOption } = this.state;
    if (selectedLocaleOption.value !== previousSelectedLocaleOption.value) {
      const locale = selectedLocaleOption.value;
      this.setState({
        selectedLocaleOption,
        locale,
        localizedNodes: Graph.localizeNodesData(nodes, locale),
      });
    }
  };

  addNode = (buttonId, lozalizedTempNode) => {
    const { edges, nodes, locale } = this.state;
    const tempNode = Object.assign({}, lozalizedTempNode, {
      name: {
        [locale]: lozalizedTempNode.name,
      },
      message: {
        [locale]: NodeMessagesLocalized[locale],
      },
    });

    return addNodeForButtonApi(buttonId, tempNode).then((newNode) => {
      const newNodes = [...nodes, newNode];
      const newEdges = [...edges, { buttonId, questionId: newNode.id }];
      this.setState({
        nodes: newNodes,
        localizedNodes: Graph.localizeNodesData(newNodes, locale),
        edges: newEdges,
      });
    }).catch(() => {
      addNotificationAction(`${locales[language].canNotAddNode}`, projectConfig.notificationLevels.error);
    });
  };

  deleteNode = node => deleteNodeaApi(node.id).then(() => {
    const { nodes, edges, locale } = this.state;
    const newNodes = nodes.filter(curNode => curNode.id !== node.id);
    const newEdges = edges.filter(curEdge => curEdge.questionId !== node.id);
    this.setState({
      nodes: newNodes,
      localizedNodes: Graph.localizeNodesData(newNodes, locale),
      edges: newEdges,
    });
  });

  connectButtonToDestination = (buttonId, destinationNode) => {
    connectEdgeToDestinationApi(buttonId, destinationNode.id).then((newEdge) => {
      const { edges } = this.state;
      const filteredEdges = edges.filter(edge => edge.id !== buttonId);
      this.setState({
        edges: [...filteredEdges, newEdge],
      });
    });
  };

  editNode = (localizedNode) => {
    const { locale, nodes } = this.state;
    const node = nodes.find(curNode => curNode.id === localizedNode.id);

    const updatedNode = Graph.getNodeUpdatedDataWithLocalization(node, localizedNode, locale);

    return editNodeApi(updatedNode).then((savedNode) => {
      const { nodes, edges, locale } = this.state;

      const newNodes = nodes.map((curNode) => {
        if (curNode.id === node.id) {
          return savedNode;
        }
        return curNode;
      });


      let allNodesButtonIds = [];
      newNodes.forEach((curNode) => {
        const nodeButtonIds = curNode.buttons.map(button => button.id);
        allNodesButtonIds = allNodesButtonIds.concat(nodeButtonIds);
      });

      const newEdges = edges.filter(edge => allNodesButtonIds.includes(edge.buttonId));

      this.setState({
        localizedNodes: Graph.localizeNodesData(newNodes, locale),
        nodes: newNodes,
        edges: newEdges,
      });
    });
  };


  static getNodeUpdatedDataWithLocalization(node, localizedNode, locale) {
    const copy = lodash.cloneDeep(node);
    copy.name[locale] = localizedNode.name;
    copy.message[locale] = localizedNode.message;
    copy.tags[locale] = localizedNode.tags;

    copy.buttons = [];
    localizedNode.buttons.forEach((button) => {
      let editedButton;
      if (button.id >= 0) {
        editedButton = node.buttons.find(curButton => curButton.id === button.id);
        editedButton.text[locale] = button.text;
      } else {
        editedButton = lodash.cloneDeep(button);
        editedButton.text = {
          [locale]: button.text,
        };
      }

      copy.buttons.push(editedButton);
    });


    copy.terminalMessage = localizedNode.terminalMessage;
    copy.chatWithOperator = localizedNode.chatWithOperator;
    copy.botAttachments = localizedNode.botAttachments;

    return copy;
  }

  static localizeNodesData = (nodes, locale) => nodes.map((node) => {
    const copy = lodash.cloneDeep(node);

    copy.name = copy.name[locale] ? copy.name[locale] : '';
    copy.message = copy.message[locale] ? copy.message[locale] : '';
    copy.tags = copy.tags[locale] ? copy.tags[locale] : [];
    copy.buttons.forEach((button) => {
      button.text = button.text[locale] ? button.text[locale] : '';
    });

    return copy;
  });

  render() {
    const {
      edges, readonly, loading, localizedNodes, selectedLocaleOption, locale, rootNodeId,
    } = this.state;
    const {
      addNotification, confirmAction, match: { url: matchUrl }, location: { pathname }, user, tariff
    } = this.props;

    const {features} = tariff;

    if (loading) {
      return (
        <LoadingComponent />
      );
    }

    const graphEditorProps = {
      nodes: localizedNodes,
      rootNodeId,
      edges,
      readonly,
      deleteNode: this.deleteNode,
      editNode: this.editNode,
      addNode: this.addNode,
      cleanTemporaryNodes: this.addNode,
      addNotification,
      confirmAction,
      connectButtonToDestination: this.connectButtonToDestination,
      user,
    };

    return (
      <div className="graph-wrapper">
        <GrapMenu pathname={pathname} basepath={matchUrl} selectedLocaleOption={selectedLocaleOption} handleLocaleChange={this.handleLocaleChange} />
        {/*{features.includes('BOT_LOGIC_GUI') &&*/}
        <Switch>
          <Route
            path={`${matchUrl}/editor`}
            render={props => (
              <GraphEditor
                {...props}
                {...graphEditorProps}
              />
            )}
          />
          {/*<Route path={`${matchUrl}/tags`} render={props => (*/}
          {/*  <Tags {...props} rootNodeId={rootNodeId} nodes={localizedNodes} edges={edges} locale={locale} user={user}*/}
          {/*/!*        editTags={this.editTags}/>)} user={user}/>*!/  tags*/}
          <Route
            path={`${matchUrl}/`}
            render={() => (<Redirect to={`${matchUrl}/editor`}/>)}
          />
        </Switch>
        // }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
});

const mapDispatchToProps = dispatch => ({
  addNotification: (message, level) => (dispatch(addNotificationAction(message, level, notificationOptParams))),
  confirmAction: (func, args) => (dispatch(confirmActionRequested(func, args))),
});

Graph.propTypes = {
  user: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  addNotification: PropTypes.func.isRequired,
  confirmAction: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  tariff: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Graph);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/graph/Graph.js